import { AppDispatch, RootState } from '../reducers/store';
import { useDispatch, useSelector } from 'react-redux';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid2 from '@mui/material/Grid2';

import { useState } from 'react';
import { CourseContentView } from './coursecontent';
import { Course } from '../model/course';

import { uuidGenerator } from './uuid';
import CircularProgress from '@mui/material/CircularProgress';
import { lineBreakModifier } from './linebreak';

import { putCourse } from '../api/courses';

import { getApiAccessToken } from '../auth/auth';
import { AxiosError } from 'axios';
import { AlertView } from './alert';
import { useMsal } from '@azure/msal-react';
import { DeleteDialog } from './deleteconfirm';
import { deleteCourseAsync } from '../reducers/courseSlice';

interface CourseProps {
    course: Course | null
}

export const CourseView = ({course}: CourseProps) => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const dispatch: AppDispatch = useDispatch();

    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setError] = useState<string | null>(null);


    const handleSaveCourse = async (course: Course | null) => {
        if (course == null) {
          console.log("could not save invalid course")
          return 
        }
  
        let [modifiedCourse, success] = uuidGenerator(course)
        if (!success) {
          setError("Could not set unique ids (uuids) on course structure")
          return
        }
  
        let [correctedCourse, ok] = lineBreakModifier(modifiedCourse)
        if (!ok) {
          // do not stop the request if modification is unsuccessfull
          setError("Storing the course, but could not modify the linebreaks in the app. \
            This can affect the spacing of the article text")
        }

        try {
            setLoading(true)

            let accessToken: string = await getApiAccessToken(instance, activeAccount)
            await putCourse(accessToken, correctedCourse.uuid, correctedCourse);

        } catch (error) {
            if (error instanceof AxiosError) {
                console.log(error)
                setError(error?.message)
            } else if (error instanceof Error) {
                console.error(error);
                setError(error?.message)
            }
        }
  
        setLoading(false)
    }

    const handleDeleteCourse = async (course: Course | null) => {
        if (course == null) {
            console.log("could not delete invalid course")
            return 
        }

        try {
            setLoading(true)
            
            let accessToken: string = await getApiAccessToken(instance, activeAccount)
            dispatch(deleteCourseAsync({accessToken, course}));

        } catch (error) {
            if (error instanceof AxiosError) {
                console.log(error)
                setError(error?.message)
            } else if (error instanceof Error) {
                console.error(error);
            }
        }
    
        setLoading(false)
    }

    return (
        <>
            <Grid2 container direction="row">
                <Typography variant="h6" color="black" align='left' margin={2}>
                    {course?.name}
                </Typography>
                <Button
                    variant="outlined" 
                    size="small"
                    onClick={() => {handleSaveCourse(course)}}
                    sx={{ maxHeight: 30, alignSelf: 'center' }}>
                    {
                        loading ? (
                        <CircularProgress size={16} />
                        ) : ('Save')
                    }
                
                </Button>
                <DeleteDialog 
                    title={
                        `Delete ${course?.name}`
                    }
                    message={`Are you sure you want to delete this course ${course?.name} ?`} 
                    onDeleteConfirmed={() => {handleDeleteCourse(course)}}
                />
            </Grid2>
            <AlertView error={errorMessage ? `${errorMessage?.substring(0, 200)}...` : null}/>
            <CourseContentView course={course}/>
        </>
    )
}